export const REPORT_ROUTES = {
  appointments: "appointments",
  completed: "completed",
  "graduation-reports": "graduation-reports",
  reports: "/",
};
